import React, {useEffect, useState} from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import { useNavigate } from "react-router-dom";
import { useGlobalOrder } from "../../utils/GlobalStateContext"; // 全局狀態
import { loginUser } from "../../reducers/authSlice";
import {useDispatch} from "react-redux";
import {BRAND, COLORS, BRAND_ASSETS} from "../../brand";

function SystemLoginPage({ setSystemLogin , setSystemData , checkAuthentication }) {
  const dispatch = useDispatch();
  const [account, setAccount] = useState(""); // 使用者帳號
  const [password, setPassword] = useState(""); // 使用者密碼
  const [error, setError] = useState(""); // 錯誤訊息
  const [loading, setLoading] = useState(false); // 載入狀態
  const { toast , playBeep } = useGlobalOrder(); // 全局 toast 提示
  const navigate = useNavigate(); // 用來導航至其他頁面

    useEffect(() => {
        if(localStorage.getItem("account") && !account){
            setAccount(localStorage.getItem("account")) ;
        }
    }, []);

  // 登入函數
  const systemLogin = async (event) => {

    event.preventDefault(); // 防止表單預設提交
    setLoading(true);
    setError(""); // 清除錯誤訊息

    dispatch(loginUser({account, password})).unwrap().then((response)=>{
        console.log(response);
        if (response.error===0) {
            checkAuthentication().then((store) => {
                navigate("/"); // 登入成功後導向首頁
                // 顯示機台身分（結帳台/內場炒台/內場出餐台），方便確認沒登錯帳號
                toast.success(store?.name ? `已成功登入：${store.name}` : "已成功登入");
                playBeep();
            });
        } else {
            toast.error(response.msg || "登入失敗，請檢查帳號和密碼");
            setError(response.msg || "登入失敗，請檢查帳號和密碼");
        }
        setLoading(false);
    });
  };

  return (
    <Box
      id="system_login_page"
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: COLORS.canvas,
        p: 3,
      }}
    >
      <Box
        sx={{
          width: "min(100%, 980px)",
          minHeight: 560,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "0.9fr 1.1fr" },
          overflow: "hidden",
          borderRadius: "16px",
          backgroundColor: "#FFF",
          border: `2px solid ${COLORS.ink}`,
          boxShadow: `6px 6px 0 ${COLORS.accent}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            p: { xs: 3, md: 4 },
            background: COLORS.ink,
            color: "#FFF",
          }}
        >
          <Box>
            <Box
              component="img"
              src={BRAND_ASSETS.icon}
              alt={BRAND.name}
              sx={{ width: 64, height: 64, borderRadius: "18px", mb: 3, display: "block" }}
            />
            <Typography sx={{ fontSize: 44, lineHeight: "50px", fontWeight: 900 }}>
              {BRAND.name}
            </Typography>
            <Typography sx={{ mt: 1, color: COLORS.highlight, fontSize: 16, fontWeight: 700, letterSpacing: ".08em" }}>
              {BRAND.nameEn}
            </Typography>
            <Typography sx={{ mt: 1.5, color: "rgba(255,255,255,0.68)", fontSize: 16 }}>
              餐飲點餐收銀系統
            </Typography>
          </Box>
          <Typography sx={{ color: "rgba(255,255,255,0.52)", fontSize: 13 }}>
            登入後可進行點餐、出餐、盤點與營業報表管理。
          </Typography>
        </Box>

        <Box
          id="login_form"
          sx={{
            p: { xs: 3, sm: 5 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box sx={{ mb: 4 }}>
            <Typography sx={{ color: COLORS.ink, fontSize: 30, fontWeight: 900 }}>
              系統登入
            </Typography>
            <Typography sx={{ color: COLORS.muted, fontSize: 15, mt: 0.75 }}>
              請輸入帳號與密碼以繼續操作。
            </Typography>
          </Box>

          <Box component="form" onSubmit={systemLogin} sx={{ display: "grid", gap: 2.25 }}>
            <TextField
              id="account"
              label="帳號"
              type="text"
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              required
              fullWidth
              autoComplete="username"
              disabled={loading}
              InputProps={{
                sx: {
                  height: 56,
                  backgroundColor: "#F8F9FA",
                  fontSize: 18,
                  fontWeight: 700,
                },
              }}
            />

            <TextField
              id="password"
              label="密碼"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              fullWidth
              autoComplete="current-password"
              disabled={loading}
              InputProps={{
                sx: {
                  height: 56,
                  backgroundColor: "#F8F9FA",
                  fontSize: 18,
                  fontWeight: 700,
                },
              }}
            />

            {error && (
              <Alert severity="error" sx={{ borderRadius: "14px", fontWeight: 700 }}>
                {error}
              </Alert>
            )}

            <Button
              type="submit"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <LockRoundedIcon />}
              sx={{
                mt: 1.5,
                height: 58,
                width: "100%",
                borderRadius: "16px",
                backgroundColor: COLORS.ink,
                color: "#FFF",
                fontSize: 18,
                fontWeight: 900,
                boxShadow: `4px 4px 0 ${COLORS.accent}`,
                "&:hover": {
                  backgroundColor: COLORS.inkDeep,
                  boxShadow: `4px 4px 0 ${COLORS.accent}`,
                },
                "&.Mui-disabled": {
                  backgroundColor: "rgba(28,45,66,0.35)",
                  color: "#FFF",
                },
              }}
            >
              {loading ? "登入中" : "登入"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default SystemLoginPage;
